import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { NoodleService } from '../../services/noodle/noodle.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { BriefService } from '../../services/brief/brief.service';
import { BriefResponseDto } from '../../common/general-types/briefs.dto';
import { NoodleBriefQuestionGroupDto, NoodleQuestionDto } from '../../common/general-types/noodle.dto';
import { QuestionEnrichComponent } from './atoms/question-enrich/question-enrich.component';

@Component({
  selector: 'app-brief-enhancements',
  standalone: true,
  imports: [QuestionEnrichComponent],
  templateUrl: './brief-enhancements.component.html',
  styleUrl: './brief-enhancements.component.css'
})
export class BriefEnhancementsComponent implements OnInit {

  showHelp = signal<boolean>(true);

  /** Refiner help card: rules configured count and total (e.g. "1 of 7 rules configured") */
  rulesConfiguredCount = computed(() => {
    const questions = this.briefQuestions()?.questions ?? [];
    return questions.filter((question: NoodleQuestionDto) => question.generalised === false).length;
  });
  rulesTotal = signal<number>(7);

  rulesNeedingConfig = computed(() => {
    const questions = this.briefQuestions()?.questions ?? [];
    return questions.filter((question: NoodleQuestionDto) => question.generalised === true).length;
  });

  briefId = signal<string | undefined>(undefined);
  brief = signal<BriefResponseDto | undefined>(undefined);
  briefQuestions = signal<NoodleBriefQuestionGroupDto | undefined>(undefined);
  doQuestions = signal<NoodleQuestionDto[] | undefined>(undefined);
  dontQuestions = signal<NoodleQuestionDto[] | undefined>(undefined);


  /** Services */
  private location = inject(Location);
  private route = inject(ActivatedRoute);
  private noodleService = inject(NoodleService);
  private briefService = inject(BriefService);
  /** Services - END */

  

  ngOnInit(): void {
    this.briefId.set(this.route.snapshot.params['briefId']);
    if (this.briefId()) {
      this.getBrief();
      this.getBriefQuestions();
    }
  }

  getBrief() {
    this.briefService.getBriefById(this.briefId()!).subscribe((brief: BriefResponseDto) => {
      // console.log('brief: ', brief);
      this.brief.set(brief);
    }, error => {
      console.error('error getting brief: ', error);
    });
  }

  getBriefQuestions() {
    this.noodleService.getBriefQuestions(this.briefId()!).subscribe((questions: NoodleBriefQuestionGroupDto) => {
      console.log('questions: ', questions);
      this.briefQuestions.set(questions);
      this.doQuestions.set(questions.questions.filter((question: NoodleQuestionDto) => question.type === 'do'));
      this.dontQuestions.set(questions.questions.filter((question: NoodleQuestionDto) => question.type === 'dont'));
    });
  }

  onQuestionEnrichmentChange(question: NoodleQuestionDto, enrichmentText: string) {
    const current = this.briefQuestions();
    if (!current) {
      return;
    }

    const updatedQuestions = current.questions.map((q: NoodleQuestionDto) =>
      q.id === question.id ? { ...q, selectedEnrichmentText: enrichmentText, enrichments: [{ text: enrichmentText }] } : q
    );

    const updatedGroup: NoodleBriefQuestionGroupDto = {
      ...current,
      questions: updatedQuestions,
      questionsCount: updatedQuestions.length
    };

    this.briefQuestions.set(updatedGroup);
    this.doQuestions.set(updatedQuestions.filter((q: NoodleQuestionDto) => q.type === 'do'));
    this.dontQuestions.set(updatedQuestions.filter((q: NoodleQuestionDto) => q.type === 'dont'));
  }

  saveBriefEnrichments() {
    console.log('saveBriefEnrichments(): ', this.briefQuestions());
    this.noodleService.saveQuestionEnrichments([this.briefQuestions()!]).subscribe((response: NoodleBriefQuestionGroupDto) => {
      console.log('response: ', response);
    }, error => {
      console.error('error saving brief enrichments: ', error);
    });
  }

  backToBrief() {
    this.location.back();
  }
}
